(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('action-form-re-render', actionFunc);

    function actionFunc(FormBuilderService, $q) {
        return function(options) {
            return $q.when(run());

            function run() {
                return FormBuilderService.rerender(options.form_name);
            }
        };
    }
})();